import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function BannerNoticias() {
  return (
    <div className="bg-sand">
      <Container fluid className="px-0">
        <Row noGutters>
          <Col md={12} className="px-0">
            <picture>
              <source
                srcSet={require("../../images/noticias/banner-noticias-m.webp")}
                media="(max-width: 576px)"
                type="image/webp"
              />                                                                        
              <img
                src={require("../../images/noticias/banner-noticias.webp")}
                alt="Hyundai Noticias"
                className="w-100 banner"
                loading="lazy"
              />
            </picture>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
export default BannerNoticias;